const api = {
    baseURL: 'http://omega.mn:5800',
    imgURL: 'http://8.araa.mn/img',
};

export default api;